import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "title is-5" }
const _hoisted_4 = { class: "table is-fullwidth" }
const _hoisted_5 = { class: "is-flex is-align-items-center is-family-monospace" }
const _hoisted_6 = { class: "buttons" }
const _hoisted_7 = { class: "box" }
const _hoisted_8 = { class: "title is-5" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "field is-grouped" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "control" }
const _hoisted_13 = { class: "is-size-7 has-text-grey" }
const _hoisted_14 = { class: "box" }
const _hoisted_15 = { class: "title is-5" }
const _hoisted_16 = {
  key: 0,
  class: "content"
}
const _hoisted_17 = {
  key: 1,
  class: "content"
}
const _hoisted_18 = { class: "field is-grouped is-align-items-center" }
const _hoisted_19 = { class: "control" }
const _hoisted_20 = {
  key: 0,
  class: "control"
}
const _hoisted_21 = { class: "is-size-7 has-text-grey" }
const _hoisted_22 = {
  key: 1,
  class: "has-text-centered"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_breadcrumb_item = _resolveComponent("b-breadcrumb-item")!
  const _component_b_breadcrumb = _resolveComponent("b-breadcrumb")!
  const _component_CopyToClipboard = _resolveComponent("CopyToClipboard")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_select = _resolveComponent("b-select")!
  const _component_esp_web_install_button = _resolveComponent("esp-web-install-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.details)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_b_breadcrumb, {
            size: "is-large",
            separator: "has-succeeds-separator",
            "aria-label": "breadcrumbs"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_b_breadcrumb_item, {
                tag: "a",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.goToList()), ["prevent"]))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('firmwares.title')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_b_breadcrumb_item, { active: "" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.shortSha(_ctx.details.sha256)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t('devices.details')), 1),
            _createElementVNode("table", _hoisted_4, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _cache[3] || (_cache[3] = _createElementVNode("td", null, [
                    _createElementVNode("strong", null, "SHA256:")
                  ], -1)),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_5, [
                      _createTextVNode(_toDisplayString(_ctx.details.sha256) + " ", 1),
                      _createVNode(_component_CopyToClipboard, {
                        value: _ctx.details.sha256,
                        title: "Copy",
                        class: "ml-1"
                      }, null, 8, ["value"])
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('firmwares.product')) + ":", 1)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(_ctx.details.productId || '—'), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('projects.title').slice(0,-1)) + ":", 1)
                  ]),
                  _createElementVNode("td", null, [
                    ((_ctx.details as any).projectId)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: { name: 'project-edit', params: { id: (_ctx.details as any).projectId } }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString((_ctx.details as any).projectName || String((_ctx.details as any).projectId)), 1)
                          ]),
                          _: 1
                        }, 8, ["to"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString((_ctx.details as any).projectName || '—'), 1)
                        ], 64))
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _cache[4] || (_cache[4] = _createElementVNode("td", null, [
                    _createElementVNode("strong", null, "Size:")
                  ], -1)),
                  _createElementVNode("td", null, _toDisplayString(_ctx.formatSize(_ctx.details.size)), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('firmwares.created')) + ":", 1)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$d(new Date(_ctx.details.createdAt), 'short')), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('firmwares.lastUpdated')) + ":", 1)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(_ctx.$d(new Date(_ctx.details.updatedAt), 'short')), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('firmwares.lastAccessed')) + ":", 1)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(_ctx.details.accessedAt ? _ctx.$d(new Date(_ctx.details.accessedAt), 'short') : '—'), 1)
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('firmwares.downloads')) + ":", 1)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(_ctx.details.downloadCount ?? 0), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_b_button, {
                type: "is-info",
                "icon-left": "download",
                onClick: _ctx.downloadFirmware
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('global.download')), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_b_button, {
                type: "is-danger",
                "icon-left": "delete",
                onClick: _ctx.confirmRemove
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('global.delete')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t('firmwares.flashOta')), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('firmwares.flashOtaDesc')), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_b_select, {
                modelValue: _ctx.selectedDeviceId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDeviceId) = $event)),
                placeholder: _ctx.$t('firmwares.flashOtaSelect')
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deviceList, (d) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: d.id,
                      value: d.id
                    }, _toDisplayString(d.name || d.id), 9, _hoisted_11))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_b_button, {
                  type: "is-danger",
                  "icon-left": "fire",
                  loading: _ctx.flashing,
                  title: _ctx.$t('projects.flashTooltip'),
                  onClick: _ctx.flashFirmware
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('projects.flash')), 1)
                  ]),
                  _: 1
                }, 8, ["loading", "title", "onClick"])
              ])
            ]),
            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('firmwares.flashOtaHint')), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.$t('firmwares.flashUsb')), 1),
            (!_ctx.supportsWebSerial)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('firmwares.flashUsbUnsupported')), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('firmwares.flashUsbDesc')), 1),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_b_button, {
                        type: "is-link",
                        loading: _ctx.preparingManifest,
                        onClick: _ctx.prepareUsbManifest
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.usbManifestUrl ? _ctx.$t('firmwares.flashUsbReady') : _ctx.$t('firmwares.flashUsbPrepare')), 1)
                        ]),
                        _: 1
                      }, 8, ["loading", "onClick"])
                    ]),
                    (_ctx.usbManifestUrl)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createVNode(_component_esp_web_install_button, { manifest: _ctx.usbManifestUrl }, null, 8, ["manifest"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t('firmwares.flashUsbHint')), 1)
                ]))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "is-size-4" }, "Not found", -1)),
          _createVNode(_component_b_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToList())),
            class: "mt-4"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('global.back')), 1)
            ]),
            _: 1
          })
        ]))
  ]))
}